// src/components/NovoVendedor.jsx
import React from "react";
import CadastroVendedor from "./CadastroVendedor";
import { cadastrarVendedor } from "../services/api";
import { useNavigate } from "react-router-dom";

const NovoVendedor = ({ token }) => {
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    try {
      await cadastrarVendedor(data, token);
      alert("Vendedor cadastrado com sucesso!");
      navigate("/vendedores");
    } catch (err) {
      const dataErr = err?.response?.data;

      if (typeof dataErr === "string") {
        alert(dataErr);
        return;
      }

      const message =
        dataErr?.message ||
        (dataErr?.errors && Object.values(dataErr.errors).flat().join("\n")) ||
        err.message ||
        "Erro ao salvar vendedor.";

      alert(message);
      console.error(err);
    }
  };

  return <CadastroVendedor onSubmit={handleSubmit} token={token} />;
};

export default NovoVendedor;
